import { createRouter, createWebHashHistory } from 'vue-router'
import Accueil from '../pages/Accueil.vue'
import Formulaire from '../pages/Formulaire.vue'
import Succes from '../pages/Succes.vue'
import Error404 from '../pages/Error404.vue'
import Erreur from '../pages/Erreur.vue'
import Reinscription from '../pages/Reinscription.vue'

export default createRouter({
    history: createWebHashHistory(),
    routes: [
        { path: '/', name: 'accueil', component: Accueil },
        { path: '/reinscription-scolaire', name: 'reinscription-scolaire', component: Reinscription },
        { path: '/inscription-maternelle-primaire', name: 'formulaire-cas-1', component: Formulaire },
        { path: '/inscription-college-lycee', name: 'formulaire-cas-2', component: Formulaire },
        { path: '/inscription-college-lycee-hors-cc2t', name: 'formulaire-cas-3', component: Formulaire },
        { path: '/reinscription/inscription-maternelle-primaire', name: 'reinscription-formulaire-cas-1', component: Formulaire },
        { path: '/reinscription/inscription-college-lycee', name: 'reinscription-formulaire-cas-2', component: Formulaire },
        { path: '/reinscription/inscription-college-lycee-hors-cc2t', name: 'reinscription-formulaire-cas-3', component: Formulaire },
        { path: '/succes/', name: 'succes', component: Succes },
        { path: '/erreur/', name: 'erreur', component: Erreur },
        { path: '/:pathMatch(.*)*', name: 'error', component: Error404 }
    ]
})